module.exports = __webpack_public_path__ + "img/serviceplanner-documenting-de.41c6ce56.webp";